'use client';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 100% !important;
  background-color: ${({ theme }) => `${theme.palette.primaryBrand}`};
  padding: 40px 0px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  min-height: 50vh;
  background: #212121;
`;

export const ErrorTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  color: ${({ theme }) => theme.palette.white};
  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    margin-top: 50px;
  }

  & > img {
    width: 100%;

    ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
      max-width: 450px;
    }
  }
  & > h3 {
    font-size: 17px;
    text-align: center;
    color: ${({ theme }) => theme.palette.white};
  }
  & > h5 {
    font-size: 21.6px;
    font-weight: 700;
    text-align: center;
    margin-top: 32px;
    color: ${({ theme }) => theme.palette.white};
  }
`;
